/* eslint-disable */
import { Row } from "antd";
import { Content } from "antd/lib/layout/layout";
import { ModalButtonYellow } from "common/modal/MoreModalButtons";
import { H3 } from "common/text";
import styled from "styled-components";

export const PageContent = styled(Content)`
  min-height: 100%;
  width: fit-content;
  margin-top: 64px;
  background-color: #1070b6;
  padding: 30px 5%;

  @media (min-width: 750px) {
    width: 100%;
  }
`;

export const CardTitle = styled.div`
  font-weight: bolder;
  color: #1070b6;
  background-color: #d3e8ff;
  text-align: center;
  font-size: 20px;
  width: 100%;
  padding: 10px 5px;
  border-radius: 2px 2px 0 0;

  @media only screen and (min-width: 1430px) {
    font-size: 25px;
    padding: 10px 20px;
  }
`;

export const Card = styled.div`
  background: white;
  padding: 15px 20px 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 0;
  border-radius: 0 0 2px 2px;
`;

export const StyledParagraph = styled.p`
  text-align: center;
  font-size: 18px;
  color: rgba(0, 0, 0, 0.7);
`;

export const StyledH3 = styled(H3)`
  text-transform: uppercase;
  margin-bottom: 10px;
`;

export const Copy = styled.div`
  border: 1.5px solid rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  width: 70%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 5px 5px 10px;
  height: 50px;
  margin: 0 auto;

  @media only screen and (min-width: 760px) {
    width: 40%;
  }

  @media only screen and (min-width: 1020px) {
    width: 60%;
  }

  @media only screen and (min-width: 1430px) {
    width: 35%;
  }
`;

export const CopyText = styled.p`
  display: inline-block;
  color: rgba(0, 0, 0, 0.5);
  align-self: center;
  margin: 0;
  font-size: 16px;
  overflow: hidden;
`;

export const CopyButton = styled.button`
  border: none;
  background-color: #fdd440;
  color: #1070b6;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 18px;
  padding: 5px 10px;
  cursor: pointer;
`;

export const StyledImage = styled.div`
  height: 200px;
  border-top-right-radius: 2px;
  border-top-left-radius: 2px;
  background-size: cover;
  background-position: center;
`;

export const StyledSection = styled(Row)`
  margin-bottom: 30px;
`;

export const LinkText = styled.a`
  color: #1070b6;
  font-weight: bold;
  text-decoration: underline;
`;

export const BigYellowButton = styled(ModalButtonYellow)`
    font-size: 20px;

    @media only screen and (min-width: 760px) {
        font-size: 24px;
    }
`;
